module.exports = __webpack_public_path__ + "img/merry.f83496fb.png";